// extracted by mini-css-extract-plugin
module.exports = {"s2i48d5":"s2i48d5"};